import React from 'react'

import { Box, Card, Icon } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { CustomQuestionsModalOptions } from './useCustomQuestion'

interface ActionCardProps {
  icon: React.ComponentProps<typeof Icon.Large>['icon']
  title: string
  description: string
  onClick: () => void
}

const ActionCard = ({ icon, title, description, onClick }: ActionCardProps) => {
  return (
    <Card onClick={onClick}>
      <Card.Eyebrow>
        <Icon.Large icon={icon} color="radicalRed1000" />
      </Card.Eyebrow>
      <Card.Title>{title}</Card.Title>
      <Card.Description>{description}</Card.Description>
    </Card>
  )
}

interface Props {
  onClose: () => void
  onSelectOption: (option: CustomQuestionsModalOptions) => void
}

export const SelectAddQuestionModal = ({ onClose, onSelectOption }: Props) => {
  return (
    <Modal
      illustration="template"
      title={i18n.t('ats.job_posting_settings.application_form.select_add_question_modal.title')}
      description={i18n.t(
        'ats.job_posting_settings.application_form.select_add_question_modal.description'
      )}
      onClose={onClose}
      disableFocusTrap
    >
      <Box flexDirection="row" gap="s24" maxWidth="sidepanelWideXL">
        <Box width="s300">
          <ActionCard
            icon="custom-file"
            title={i18n.t(
              'ats.job_posting_settings.application_form.select_add_question_modal.from_scratch_title'
            )}
            description={i18n.t(
              'ats.job_posting_settings.application_form.select_add_question_modal.from_scratch_description'
            )}
            onClick={() => {
              onSelectOption('fromScratch')
            }}
          />
        </Box>
        <Box width="s300">
          <ActionCard
            icon="template"
            title={i18n.t(
              'ats.job_posting_settings.application_form.select_add_question_modal.from_template_title'
            )}
            description={i18n.t(
              'ats.job_posting_settings.application_form.select_add_question_modal.from_template_description'
            )}
            onClick={() => {
              onSelectOption('fromTemplates')
            }}
          />
        </Box>
      </Box>
    </Modal>
  )
}
